import {
  Button,
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Modal,
  Typography,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import ValueCalculator from "../ValueCalculator";
import Swipper from "../Swipper";

interface IWheel {
  id: number;
  img?: string;
  name: string;
  size: number;
  brand: string;
  hardness: string | number;
  price: number;
  quantity: number;
  state: string;
}

const TypographyCentered = styled(Typography)`
  align: center;
`;

const Wheel: React.FC<IWheel> = ({ img, name, size, brand, hardness, price, quantity, state }) => {
  const { t } = useTranslation();
  const images = img?.length ? img?.split(",").map((path) => { return `Wheels/${path.trim()}` }) : ["NoImage.jpg"];
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    (async () => {
      const dolarPrice: number = await ValueCalculator(price);
      setValue(dolarPrice as number)
    })()
  });

  return (
    <>
      <Card sx={{ maxWidth: 345 }}>
        <CardMedia
          key={images[0]}
          sx={{
            padding: "1em 1em 0 1em",
            objectFit: "contain"
          }}
          component="img"
          height={240}
          width={345}
          title="wheel"
          image={require(`../../Assets/${images[0].trim()}`)}
          onClick={handleOpen}
          loading="lazy"
        ></CardMedia>
        <CardContent>
          <Typography gutterBottom variant="h5" component="p" align="center">
            {name}
          </Typography>
          <TypographyCentered>{brand}</TypographyCentered>
          <TypographyCentered>
            {size}mm / {hardness}
          </TypographyCentered>
          <TypographyCentered gutterBottom color={state === "new" ? "red" : "black"}>
            {state === "new" ? t("card.state.new") : t("card.state.used")}
          </TypographyCentered>
        </CardContent>
        <CardActions>
          <ButtonGroup orientation="vertical" fullWidth>
            <TypographyCentered variant="subtitle1" border={2}>
              {t("common.wheel", { count: quantity })} / ${value}
            </TypographyCentered >
            <Button variant="contained" size="small" onClick={() => window.open(`https://wa.me/5493513901837?text=${encodeURIComponent(`${t("common.buy_message")}: \nWheel ${name} - ${size}mm - ${hardness} - ${state === "new" ? t("card.state.new") : t("card.state.used")} - $${value}`)}&attachment=${encodeURIComponent(`Wheels/${images[0].trim()}`)}`)}>
              {t("common.buy")}
            </Button>
          </ButtonGroup>
        </CardActions>
      </Card>
      <Modal open={open}>
        <>
          <Swipper images={images} size={{ height: "550vw", width: "100vw" }} onImageClick={() => { return null; }} close={handleClose}></Swipper>
        </>
      </Modal>
    </>
  );
};

export type { IWheel };
export default React.memo(Wheel);
